import { Construction } from "lucide-react";
import { Navigate, useParams } from "react-router-dom";
import { Empty } from "../components/ui";
import type { AppId, Me } from "../lib/api";
import { activeOption, useConnections } from "../lib/connections";

/** /apps/<appId>/…: each app mounts here once it's built (Job Automation from phase 2). */
export default function AppPlaceholder({ me }: { me: Me }) {
  const { appId } = useParams();
  const app = me.apps?.find((a) => a.id === appId);
  const conns = useConnections();
  if (!app) return <Navigate to="/" replace />;
  const active = activeOption(conns.apps[app.id as AppId]);
  return (
    <Empty icon={<Construction className="size-8" />} title={app.name}>
      {active ? `Working against ${active.name} (${active.envLabel}). ` : "Choose an Infor connection with the button at the top right. "}
      This app isn't available in the portal yet.
    </Empty>
  );
}
